/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_DurationInputs */

const en_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const de_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const es_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const fr_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

const nl_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duur`)
};

const it_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

const pt_br2_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

const pl_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas trwania`)
};

const hu_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Időtartam`)
};

const ro_admin_plan_discount_form_duration = /** @type {(inputs: Admin_Plan_Discount_Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Admin_Plan_Discount_Form_DurationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_duration = /** @type {((inputs?: Admin_Plan_Discount_Form_DurationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_DurationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_duration(inputs)
	if (locale === "de") return de_admin_plan_discount_form_duration(inputs)
	if (locale === "es") return es_admin_plan_discount_form_duration(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_duration(inputs)
	if (locale === "nl") return nl_admin_plan_discount_form_duration(inputs)
	if (locale === "it") return it_admin_plan_discount_form_duration(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_duration(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_duration(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_duration(inputs)
	return ro_admin_plan_discount_form_duration(inputs)
});
export { admin_plan_discount_form_duration as "admin.plan_discount_form.duration" }